// Cat in a Flat domains
export const CAT_IN_A_FLAT_DOMAINS = [
  'ciaf.local', // Local development
  'catinaflat.dev', // Staging
  'catinaflat.com', // Production - International
  'catinaflat.co.uk', // Production - UK
  'catinaflat.de', // Production - Germany
  'catinaflat.es', // Production - Spain
];
